import { imageResize } from 'components/Widgets/utils';
import React from 'react';

export const useImageLoader = (url: string, maxWidth?: number, loadWithDelay?: number) => {
    const [imageDimensions, setImageDimensions] = React.useState<{ width: number; height: number }>({
        width: 0,
        height: 0,
    });
    const [loading, setLoading] = React.useState<boolean>(true);
    const [error, setError] = React.useState<boolean>(false);

    const load = React.useCallback(() => {
        setLoading(true);
        setImageDimensions({ height: 0, width: 0 });
        const img = new Image();
        img.src = url;
        img.onload = () => {
            setLoading(false);
            if (maxWidth !== undefined) {
                const { width, height } = imageResize(img.width, img.height, maxWidth, 0);
                setImageDimensions({ height, width });
            } else {
                setImageDimensions({
                    height: img.height,
                    width: img.width,
                });
            }
            setError(false);
        };
        img.onerror = () => {
            setError(true);
        };
    }, [url, maxWidth]);

    React.useEffect(() => {
        if (loadWithDelay !== 0) {
            load();
        }
    }, [url, maxWidth, loadWithDelay, load]);

    return { loading, error, width: imageDimensions.width, height: imageDimensions.height, load };
};
